import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'wix-ui-tpa';
// @ts-ignore
import InfoCircle from 'wix-ui-icons-common/InfoCircle';
import { st, classes } from './Error.st.css';
var Error = function (_a) {
    var localeToggle = _a.localeToggle, error = _a.error, isLiveSite = _a.isLiveSite;
    var t = useTranslation()[0];
    return (React.createElement("div", { className: st(classes.root, { isLiveSite: isLiveSite }) },
        React.createElement(InfoCircle, { className: classes.InfoCircle }),
        React.createElement(Text, { className: classes.ErrorMessage }, t(error))));
};
export default React.memo(Error);
//# sourceMappingURL=Error.js.map